export type WidgetEntryScope = 'shop' | 'barber' | null;

export interface WidgetEntryRestrictions {
  canChangeBarber: boolean;
  canChangeLocation: boolean;
}

const pathSegments = (href: string): string[] => {
  try {
    return new URL(href).pathname.split('/').filter(Boolean);
  } catch {
    return [];
  }
};

// The loader's `viewMode` param restates this path, so the path is the one
// source the app reads (SQR-13809).
export const getWidgetEntryScope = (
  href: string | undefined,
): WidgetEntryScope => {
  if (!href) return null;
  const [booking, book, shop, barber, barberId] = pathSegments(href);
  if (booking !== 'booking' || book !== 'book' || !shop) return null;
  return barber === 'barber' && barberId ? 'barber' : 'shop';
};

export const getWidgetEntryRestrictions = (
  scope: WidgetEntryScope,
): WidgetEntryRestrictions => ({
  canChangeBarber: scope !== 'barber',
  canChangeLocation: scope === null,
});
